<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" fill="none" viewBox="0 0 24 18">
    <path :fill="fill" d="M24 4.587C24 2.605 22.394.998 20.413.998H3.586C1.606.998 0 2.605 0 4.587v9.622c0 1.982 1.605 3.589 3.586 3.589h16.827c1.981 0 3.587-1.607 3.587-3.589V4.587zm-14.401 8.87V4.42l6.854 4.52L9.6 13.457z"/>
  </svg>
</template>

<script>
  export default {
    name: "Youtube",
    props: ['fill']
  }
</script>

<style scoped>

</style>